import { Component } from '@angular/core';
import { NavigationComponent } from '@spartacus/storefront';
import { MyAccountNavigationUiComponent } from '../my-account-navigation-ui/my-account-navigation-ui.component';
import { NgClass, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-efa-navigation',
    templateUrl: './efa-navigation.component.html',
    imports: [MyAccountNavigationUiComponent, NgClass, AsyncPipe]
})
export class EfaNavigationComponent extends NavigationComponent {
}
